import { delay } from 'utils';
import { EventHandler } from './../types';
import { event, getProgressLevel } from './../helpers';

const EVENT_BASED: EventHandler[] = [
  event(
    'ANALYTICS_INIT',
    ({ send }) => send('metrics', 'game_ready', null, null, null, true),
  ),
  event(
    'PLAY',
    ({ send }) => send('metrics', 'play_clicked'),
  ),
  event(
    'MIX_NEW',
    async ({ send, $store }) => {
      await delay(500);
      const current = $store.getters.totalProgress;

      const progressLevel = getProgressLevel(current);
      if (progressLevel) {
        send('metrics', 'total_progress', progressLevel, +progressLevel);
      }
    },
  ),
  event(
    'TUTORIALS_FINISHED',
    ({ send }) => send('metrics', 'tutorials_finished'),
  ),
  event(
    'HINTS_CLICKED',
    ({ send, $store }) => {
      send('metrics', 'hints_clicked');
      send('user', 'opens hints - fails streak', $store.getters.sessionFailStreak);
    },
  ),
  event(
    'UNLOAD',
    ({ send, $store }) => send('user', 'leaves - fails streak', $store.getters.sessionFailStreak),
  ),
];

export default EVENT_BASED;
